import './styles.scss';

import { useRef } from 'react';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import feedback1 from '../../assets/feedback-1.png';
import feedback2 from '../../assets/feedback-2.png';
import feedback3 from '../../assets/feedback-3.png';
import feedback4 from '../../assets/feedback-4.png';
import feedback5 from '../../assets/feedback-5.png';
import feedback6 from '../../assets/feedback-6.png';
import redIdentity from '../../assets/red-identity.png';


SwiperCore.use([Navigation]);

function Feedback() {
    const swiperRef = useRef(null);

    const imagesFeedback = [feedback1, feedback2, feedback3, feedback4, feedback5, feedback6];

    const nextSlide = () => swiperRef.current?.slideNext();
    const prevSlide = () => swiperRef.current?.slidePrev();

    return (
        <div className="container-feedback">
            <h1>Feedbacks</h1>
            <div className="feedback-carousel">
                <i className="fa fa-angle-left" onClick={prevSlide}></i>

                <Swiper
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    spaceBetween={10}
                    slidesPerView={3}
                    centeredSlides={true}
                    loop={true}
                    speed={1000}
                >
                    {imagesFeedback.map((img, index) => (
                        <SwiperSlide key={index}>
                            <a
                                href="https://www.google.com.br/search?q=lais+muhana#lrd=0x7161b8a051c9de3:0xdc615d4359d7333d,1"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src={img} alt='Feedback' className="carousel-image" />
                            </a>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <i className="fa fa-angle-right" onClick={nextSlide}></i>
            </div>

            <img className="feedback-identity" src={redIdentity} alt="DLM" />
        </div>
    );
}

export default Feedback;